const getPatientPhone3 = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const primaryPhone = patient['Contact Information']
    ? patient['Contact Information']['Primary Phone']
    : null;
  if (primaryPhone) {
    return primaryPhone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(6, 10);
  }
  return null;
};

export default getPatientPhone3;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientPhone3.js